export const red900 = '#42080D';
export const red800 = '#6E0D15';
export const red700 = '#99121E';
export const red600 = '#C31726';
export const red500 = '#ED1C2E';
export const red400 = '#F44554';
export const red300 = '#F9747F';
export const red200 = '#FFAFB5';
export const red100 = '#FFEAEC';

export const orange900 = '#663F00';
export const orange800 = '#875400';
export const orange700 = '#A86800';
export const orange600 = '#CC7F00';
export const orange500 = '#ED9300';
export const orange400 = '#F2AB38';
export const orange300 = '#F5C371';
export const orange200 = '#FADCAC';
export const orange100 = '#FFF7EB';

export const yellow900 = '#413108';
export const yellow800 = '#70580E';
export const yellow700 = '#A08214';
export const yellow600 = '#CFAD1A';
export const yellow500 = '#FFD520';
export const yellow400 = '#FFDE51';
export const yellow300 = '#FFE883';
export const yellow200 = '#FFF1B4';
export const yellow100 = '#FFFAE6';

export const green900 = '#143205';
export const green800 = '#1F4D09';
export const green700 = '#2A640E';
export const green600 = '#3E8619';
export const green500 = '#58B02C';
export const green400 = '#75C24E';
export const green300 = '#96D577';
export const green200 = '#BBE7A4';
export const green100 = '#E3FAD8';

export const blue900 = '#003C51';
export const blue800 = '#00506E';
export const blue700 = '#00658A';
export const blue600 = '#0079A6';
export const blue500 = '#008EC2';
export const blue400 = '#31A6D1';
export const blue300 = '#68C0E1';
export const blue200 = '#A7DCF0';
export const blue100 = '#EDFAFF';

export const gray900 = '#1D2325';
export const gray800 = '#2F373B';
export const gray700 = '#444F55';
export const gray600 = '#586369';
export const gray500 = '#7F898F';
export const gray400 = '#B4B9BB';
export const gray300 = '#DADADA';
export const gray200 = '#ECECEC';
export const gray100 = '#FAFAFA';
